import React from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';
import Velocity from 'velocity-animate';

import Analytics from '@module/analytics';
import SplashpageHelper from '@app/helper/splashpage';

class FreeAccount extends React.PureComponent {
  componentDidMount() {
    window.addEventListener('keydown', this.handleEscape);

    SplashpageHelper.trackShow();
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleEscape);
  }

  onExit(component) {
    Velocity(
      component,
      {
        scale: '1.3',
        opacity: 0,
      },
      { duration: 300 }
    );
  }

  handleEscape = (event) => {
    if (event.key !== 'Escape') {
      return;
    }

    SplashpageHelper.trackFreeFunnel({
      action: 'click_i_just_want_to_send_my_files',
    });

    this.props.onEscape();
  };

  handleFreeAccountClick = (event) => {
    // Stop Triggering GA tracker in handleClick()
    event.stopPropagation();

    Analytics.trackStructEvent({
      category: 'splashscreen',
      action: 'click_create_an_account',
    });

    this.props.onPlusClick();
  };

  handleFreeClick = (event) => {
    // Stop Triggering GA tracker in handleClick()
    event.stopPropagation();

    SplashpageHelper.trackFreeFunnel({
      action: 'click_i_just_want_to_send_my_files',
    });

    this.props.onFreeClick();
  };

  handlePlusClick = (event) => {
    // Stop Triggering GA tracker in handleClick()
    event.stopPropagation();

    SplashpageHelper.trackPlusFunnel();

    this.props.onPlusClick();
  };

  handleClick = () => {
    SplashpageHelper.trackFreeFunnel({
      action: 'click_i_just_want_to_send_my_files',
    });

    this.props.onClick();
  };

  render() {
    return (
      <Transition
        in={this.props.in}
        timeout={{ in: 0, exit: 300 }}
        unmountOnExit={true}
        onExit={this.onExit}
      >
        <div
          className="splashpage free-account-tiers"
          onClick={this.handleClick}
        >
          <div>
            <div className="splashpage__background" />

            <div className="content">
              <h1 className="content__heading">
                WeTransfer is the best way to send big files
                <br />
                Get more out of WeTransfer
              </h1>

              <div className="tiers__list">
                <div className="tier">
                  <div className="tier__content">
                    <h2 className="tier__title">WeTransfer Account</h2>
                    <h3 className="tier__subtitle">Free</h3>
                    <ul className="tier__features">
                      <li className="tier__feature-item">
                        Send up to <strong>2GB</strong>
                      </li>
                      <li className="tier__feature-item">Manage transfers</li>
                      <li className="tier__feature-item">
                        Store up to <strong>5GB</strong>
                      </li>
                    </ul>
                  </div>
                  <button
                    className="button button--enabled"
                    onClick={this.handleFreeAccountClick}
                  >
                    Create an account
                  </button>
                </div>

                <div className="tier">
                  <div className="tier__content">
                    <h2 className="tier__title">WeTransfer Plus</h2>
                    <h3 className="tier__subtitle">
                      <div className="tier__price">
                        <span>$12</span>
                        <sup>USD</sup>
                        <span className="tier__period">/ month</span>
                      </div>
                    </h3>
                    <ul className="tier__features">
                      <li className="tier__feature-item">
                        Send up to <strong>20GB</strong>
                      </li>
                      <li className="tier__feature-item">Manage transfers</li>
                      <li className="tier__feature-item">
                        Store up to <strong>100GB</strong>
                      </li>
                      <li className="tier__feature-item">
                        Your own backgrounds
                      </li>
                      <li className="tier__feature-item">A custom URL</li>
                      <li className="tier__feature-item">
                        Password-protect transfers
                      </li>
                    </ul>
                  </div>
                  <button
                    className="button button--enabled button--inline"
                    onClick={this.handlePlusClick}
                  >
                    Get WeTransfer Plus
                  </button>
                </div>
              </div>

              <div className="free-button-wrapper">
                <button
                  className="button button--enabled button--inline free-button"
                  onClick={this.handleFreeClick}
                >
                  I just want to send my files
                </button>
              </div>
            </div>
          </div>
        </div>
      </Transition>
    );
  }
}

FreeAccount.propTypes = {
  in: PropTypes.bool,
  onEscape: PropTypes.func.isRequired,
  onFreeClick: PropTypes.func.isRequired,
  onPlusClick: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default FreeAccount;
